// extracted by mini-css-extract-plugin
module.exports = {"detailPanel":"antd-pro-pages-editor-flow-components-editor-detail-panel-index-detailPanel"};